import React, { useState, useEffect }  from 'react';


// react-bootstrap
import { Card, Row, Col } from 'react-bootstrap';

// project import
// import Breadcrumb from '../../../layouts/AdminLayout/Breadcrumb';

// assets
// import logo from '../../../logo.png';
import logo from '../../../assets/Images/logo.png'

// ==============================|| RESET PASSWORD 1 ||============================== //

const ResetPassword1 = () => {
  const [district] = useState("");  // State for the selected district
  const [username, setUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [districts, setDistricts] = useState([]);  // Initialize as an empty array

  useEffect(() => {
    const fetchDistricts = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/districts`);
        const data = await response.json();
        
        // Check if the response is an array
        if (Array.isArray(data)) {
          setDistricts(data);  // Set districts if response is an array
        } else {
          console.error('Invalid response format: districts should be an array');
        }
      } catch (error) {
        console.error('Error fetching districts:', error);
      }
    };
    fetchDistricts();
  }, []);

 

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("District:", district);
    console.log("Username:", username);
    console.log("New Password:", newPassword);
  };
  return (
    <React.Fragment>
      {/* <Breadcrumb /> */}
      <div className="auth-wrapper">
        <div className="auth-content text-center">
          <Card className="borderless">
            <Row className="align-items-center text-center">
              <Col>
                <Card.Body className="card-body">
                  <img src={logo} alt="" className="img-fluid mb-4" style={{ width:'50px',height:'auto',margin:'10px',borderRadius:'50px',backgroundColor:'white' }} />
                  <h4 className="mb-3 f-w-400">Reset your password</h4>
                  <form onSubmit={handleSubmit}>
                  <div className="input-group mb-4">
                    <select type="password" className="form-control" placeholder="District" >
                    <option value="" required>Select Present District</option>
                      {districts.length > 0 ? (
                        districts.map((district, index) => (
                          <option key={index} value={district.DISTRICT_ID}>
                            {district.DISTRICT_NAME}
                          </option>
                        ))
                      ) : (
                        <option disabled>Loading districts...</option>
                      )} 
                    </select>
                  </div> 
                  <div className="input-group mb-4">
                    <input type="text" className="form-control" placeholder="Username" id="username"
                       value={username}     onChange={(e) => setUsername(e.target.value)} required
                    />
                  </div>
                  <div className="input-group mb-4">
                    <input type="password" className="form-control" placeholder="New password"   id="newPassword"
                      value={newPassword}   onChange={(e) => setNewPassword(e.target.value)}  required/>
                  </div>
                  <button type="submit" className="btn btn-primary btn-block mb-4">Submit</button>
                  </form>
                </Card.Body>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResetPassword1;
